//  ----------      START   IMPORT  BLOCK       ----------
import DocsContainer from '../DocsLayout/DocsContainer';
import BaseLayout from '../BaseLayout/BaseLayout';
import { getProfessionalsContent } from './ProfessionalsContent';
//  Context
import { useLanguage } from '../../../../../API/Context/LanguageContext';
import { useParams } from 'react-router-dom';
//  Condig
import { FRONTEND_ROUTES } from '../../../../../ConfigFiles/Routes/frontend_routes';
//  ----------      END   IMPORT  BLOCK       ----------


function AboutBasePage({  }) {
  //  Consume context
  const { lan } = useLanguage();
  const { sectionId } = useParams();

  const content = getProfessionalsContent(lan)

  return (
    <BaseLayout>
      <DocsContainer sections={content} basePath={FRONTEND_ROUTES.static_professionals}/>
    </BaseLayout>
  );
}

export default AboutBasePage;

